import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { getOracle } from "../../utils/contractHelpers";
import { useRecoilValue } from "recoil";
import { userSmartAccount } from "../../components/RecoilAtom";

const WinnerFinalizedBool = () => {
    const web3 = useWeb3();
    const smartAccount = useRecoilValue(userSmartAccount)
    const WinnerFinalizedBoolHook = useCallback(async (resolverdata) => {
        if (!resolverdata) return
        const contract = getOracle(resolverdata, web3);
        const winnerfinalized = await contract.methods.winnerFinalized().call()
        return winnerfinalized;
    }, [web3, smartAccount]);
    return { WinnerFinalizedBoolHook };
};

export default WinnerFinalizedBool;
